"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localText = void 0;
exports.localText = {
    edit: function (name) { return "Edit ".concat(name); },
    noEditAccess: function (name) { return "You have no permission to edit ".concat(name); },
    notAddedYet: 'Not added yet',
    undefined: 'Undefined',
};
